import { render, staticRenderFns } from "./almondco-inshell-allocation-list.vue?vue&type=template&id=91cabef0"
import script from "./almondco-inshell-allocation-list.vue?vue&type=script&lang=js"
export * from "./almondco-inshell-allocation-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports